import UgcToolsHistory from "./History";

export default UgcToolsHistory;
